// Constants.
import * as AlertConstants from 'constants/AlertConstants';
import * as AuthConstants from 'constants/AuthConstants';


const initialState = {
  message: '',
  status: '',
};

export default function alert(state = initialState, action = {}) {
  switch (action.type) {
    case AlertConstants.ALERT_MESSAGE_SEND:
      return {
        ...state,
        message: action.message,
        status: action.status,
      };
    case AuthConstants.LOGOUT_SUCCESS:
    case AuthConstants.LOGOUT_TOKEN_SUCCESS:
      return {
        ...state,
        message: '',
        status: '',
      };
    default:
      return state;
  }
}
